<script setup>
import rewriteImageUrl from '~/utils/rewrite-image-url';

const { $get } = useApi()

const { data: category } = await useAsyncData(
  'get active categories',
  () => $get('/api/v1/category?isActive=true&_sort=priority:asc'),
  {
    default: () => [],
    lazy: true
  }
)

const isWeekend = computed(() => {
  const now = new Date()
  return new Date(now).getDay() === 0 || new Date(now).getDay() === 6
})

const isFriday = computed(() => {
  const now = new Date()
  return new Date(now).getDay() === 5
})

const isOpen = ref(false)

const selectedDate = ref()

async function onSelectDate (value) {
  selectedDate.value = value
  await navigateTo(`/events-by-dates?day=${selectedDate.value}`)
}

const isMounted = ref(false)

onMounted(() => {
  isMounted.value = true
})
</script>

<template>
  <NuxtLayout name="main-shop-layout">
    <div class="container px-4 pb-17 lg:pb-0 mx-auto lg:hidden">
      <div class="mt-6 w-full flex flex-col space-y-8">
        <a-search-input />

        <div class="flex flex-col space-y-4">
          <div class="text-sf-pro text-center text-2xl font-semibold">
            Дата
          </div>
          <div class="flex justify-center items-center flex-wrap gap-2">
            <nuxt-link :to="`/events-by-dates?day=today`">
              <t-button rounded="large" font-size="base" height="small" class="!font-normal px-6">
                Сегодня
              </t-button>
            </nuxt-link>
            <nuxt-link v-if="!isFriday" to="/events-by-dates?day=tomorrow">
              <t-button rounded="large" font-size="base" height="small" class="!font-normal px-6">
                Завтра
              </t-button>
            </nuxt-link>
            <nuxt-link to="/events-by-dates?day=weekend">
              <t-button
                v-if="!isWeekend"
                rounded="large"
                font-size="base"
                height="small"
                class="!font-normal px-6"
              >
                В выходные
              </t-button>
            </nuxt-link>

            <div class="rounded-full cursor-pointer px-3 py-2 bg-primary-100" @click="isOpen = true">
              <a-icon-calendar class="w-5 h-5" />
            </div>
          </div>
        </div>

        <div class="flex flex-col space-y-4">
          <div class="text-sf-pro text-center text-2xl font-semibold">
            События
          </div>
          <div
            v-if="category && category.length"
            class="flex justify-center items-center flex-wrap gap-4"
          >
            <nuxt-link v-for="item in category" :key="item.id" :to="`/categories/${item.slug}`">
              <div
                class="flex px-4 py-2 rounded-3xl items-center flex-row space-x-2"
                style="box-shadow: 0px 3px 12px #1414141f"
              >
                <img :data-blink-src="rewriteImageUrl(item.icon.uploadURL)" class="!w-5 !h-5" />
                <div class="font-sf-pro text-base">
                  {{ item.title }}
                </div>
              </div>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-if="isOpen" class="relative md:hidden" @close="isOpen = false">
      <a-icon-close
        class="top-7 left-4 cursor-pointer absolute w-4 h-4"
        style="z-index: 115"
        @click="isOpen = false"
      />
      <t-full-calendar v-if="isMounted" class="mb-12" style="height: 100vh" @select-date="onSelectDate" />
    </a-modal>
  </NuxtLayout>
</template>
